import {UserSummariesAction} from '../actions/user-summaries.action';
import {TOGGLE_USER_SUMMARIES, ToggleUserSummaries} from "../actions";
import {TypeUtils} from "../../shared/utils/type-utils";

export interface IUserSummariesState {
  toggled: boolean;
}

export const initialState: IUserSummariesState = {
  toggled: false
};

export function reducer(state: IUserSummariesState = initialState, action: UserSummariesAction): IUserSummariesState {
  switch (action.type) {

    case TOGGLE_USER_SUMMARIES:
      let toggled: boolean = (<ToggleUserSummaries>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
